import { KeyedResource } from './keyed.resource';

export class ListResource extends KeyedResource {
  private listNameImpl: string;
  private chartNameImpl: string;

  constructor(args: any) {
    super(args, args.listName);

    this.resourceType = 'list';

    if (this.uiResourceName) {
      const result = this.uiResourceName.split('.');
      this.listNameImpl = result[ 0 ];

      if (result.length > 1) {
        this.chartNameImpl = result[ 1 ];
      }
    }
  }

  public get listName() {
    return this.listNameImpl;
  }

  public get chartName() {
    return this.chartNameImpl;
  }
}
